import type { Learner } from '@/types'

// FE readingStage (0..5) → backend learner_stage numeric tier.
// Stage 0 maps to null, which signals the pre-reader oral-guide pipeline
// server-side. Shared by /api/generate/analyze and /api/generate/activities.
const STAGE_TO_BACKEND: Record<number, number | null> = {
  0: null,
  1: 2.0,
  2: 2.5,
  3: 3.0,
  4: 3.5,
  5: 4.0,
}

export function mapLearnerStageToBackend(
  readingStage: Learner['readingStage'] | undefined,
): number | null {
  if (readingStage == null) return null
  return STAGE_TO_BACKEND[readingStage] ?? null
}
